import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(
    private http: HttpClient
  ) { }

  getLatestVersion(platfrom): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/public/get-version?platform=' + platfrom);
  }
}
